import { Stack, Text, useDisclosure } from '@chakra-ui/react'
import { useSearchParams } from 'next/navigation'

import ModalV3 from '@/components/UI/Modal/ModalV3'

export default function SeriesModal() {
  const params = useSearchParams()
  const { isOpen: attendanceModalOpen, onClose: closeAttendanceModal } = useDisclosure({
    defaultIsOpen: params?.get('open') === 'confirm-attendance',
  })
  return attendanceModalOpen ? (
    <ModalV3
      title="Participation Confirmed"
      size="lg"
      open={attendanceModalOpen}
      onClose={closeAttendanceModal}
      body={() => (
        <Stack spacing="8px">
          <Text>
            🎉 You&apos;re all set! Thanks for confirming — your tutor and fellow learners are
            looking forward to seeing you!
          </Text>
        </Stack>
      )}
    />
  ) : null
}
